import '../css/style.css';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS.js';
import * as olProj from 'ol/proj';
import {useGeographic} from 'ol/proj.js';

useGeographic();

export const map = new Map({
  target: 'map'
});

const layer_osm = new TileLayer({source: new OSM()});
map.addLayer(layer_osm);

map.setView(new View({
  center: [27.78, 46.44],
  zoom: 9,
}));

window.layer_parcels = new TileLayer();

map.addLayer(layer_parcels);

